/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Meeting_Topics_Judged_AtInputs */



/**
* | output |
* | --- |
* | "Judged on {date}" |
*
* @param {Meeting_Topics_Judged_AtInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meeting_topics_judged_at = /** @type {((inputs: Meeting_Topics_Judged_AtInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Topics_Judged_AtInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ (`Beoordeeld op ${i?.date}`)
	if (locale === "fr") return /** @type {LocalizedString} */ (`Évalué le ${i?.date}`)
	return /** @type {LocalizedString} */ (`Judged on ${i?.date}`)
});